import React from "react";
import { Header, KarigarProductOrders } from "../components";
import { Box } from "@mui/material";

const Home = () => {
  return (
    <Box>
      <Header />
      <KarigarProductOrders />
    </Box>
  );
};

export default Home;
